import { createTheme } from "@mui/material/styles";
import { BRAND } from "../components/auth/authTheme";

const appTheme = createTheme({
  palette: {
    primary: {
      main: BRAND.orange,
      dark: BRAND.orangeHover,
      light: BRAND.orangeLight,
      contrastText: "#fff",
    },
    secondary: {
      main: BRAND.navy,
      contrastText: "#fff",
    },
    text: {
      primary: BRAND.text,
      secondary: BRAND.muted,
    },
    background: {
      default: BRAND.bg,
      paper: "#fff",
    },
    divider: BRAND.border,
    success: {
      main: BRAND.success,
      dark: BRAND.successHover,
    },
  },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h5: { color: BRAND.navy, fontWeight: 700 },
    h6: { color: BRAND.navy, fontWeight: 600 },
    subtitle1: { color: BRAND.navy, fontWeight: 600 },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 10,
        },
        containedPrimary: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 4px 14px rgba(255,106,0,0.35)",
          },
        },
        outlinedPrimary: {
          borderColor: BRAND.orange,
          "&:hover": {
            borderColor: BRAND.orangeHover,
            backgroundColor: BRAND.orangeLight,
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        colorPrimary: {
          color: BRAND.orange,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: BRAND.orange,
          fontWeight: 600,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 16,
          border: `1px solid ${BRAND.border}`,
          boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
        },
        paperFullScreen: {
          borderRadius: 0,
          margin: 0,
          maxHeight: "100%",
          maxWidth: "100%",
          border: "none",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRadius: 0,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          color: BRAND.navy,
          fontWeight: 700,
          fontSize: "1.125rem",
          paddingBottom: 8,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "small",
      },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 10,
            "& fieldset": { borderColor: BRAND.border },
            "&:hover fieldset": { borderColor: "#CBD5E1" },
            "&.Mui-focused fieldset": {
              borderColor: BRAND.orange,
              borderWidth: "1.5px",
            },
            "&.Mui-focused": {
              boxShadow: `0 0 0 3px ${BRAND.orangeLight}`,
            },
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: BRAND.orange,
          height: 3,
          borderRadius: "3px 3px 0 0",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          color: BRAND.muted,
          "&.Mui-selected": {
            color: BRAND.orange,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: BRAND.orangeLight,
          color: BRAND.orange,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: BRAND.border,
          "&.Mui-checked": {
            color: BRAND.orange,
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          "&.Mui-checked": {
            color: BRAND.orange,
            "& + .MuiSwitch-track": {
              backgroundColor: BRAND.orange,
              opacity: 0.5,
            },
          },
        },
      },
    },
  },
});

export default appTheme;
